export const AI_ACT_QUESTIONNAIRE_SLUGS = {
    full: "ai_risk_assessment",
    standard: "ai_risk_assessment_standard"
};

/**
 * `ai_setup_mode` is sent as a boolean by the API, but tolerate the string /
 * numeric shapes the backend uses elsewhere for the same flag.
 */
const STANDARD_AI_SETUP_MODES = [true, "true", 1, "1", "standard"];

export const isStandardAiSetupMode = (aiSetupMode) => {
    return STANDARD_AI_SETUP_MODES.includes(aiSetupMode);
};

/**
 * Third-party assets answer the Standard AIRA questionnaire; own development
 * keeps the Full one.
 */
export const getAiActQuestionnaireSlug = (aiSetupMode) => {
    return isStandardAiSetupMode(aiSetupMode)
        ? AI_ACT_QUESTIONNAIRE_SLUGS.standard
        : AI_ACT_QUESTIONNAIRE_SLUGS.full;
};
